const BASE_SIZE = 16; // always set to your html's base font size.

type mode = 'rem' | 'em';

export const px2rem = (px: number, mode: mode = 'rem'): string => {
  return `${px / BASE_SIZE}${mode}`;
};
